import React from 'react';
import styles from './Avatar.less';

export default ({ avatar, size }) => (
  <div
    className={styles.avatar}
    style={{ backgroundImage: `url(${avatar})`, width: size || 50, height: size || 50 }}
  />
);
